import ListItem from '../items/ListItem';
import * as theme from '../../../theme';
import { useNavigate } from "react-router";
import dayjs from 'dayjs';

export default function ScanList({ scans, clientId }) {
  const navigate = useNavigate();

  // Sort scans by scanDate in descending order (newest first)
  const sortedScans = scans ? [...scans].sort((a, b) => dayjs(b.scanDate).valueOf() - dayjs(a.scanDate).valueOf()) : [];

  return (
    <div style={theme.Container.listColumn}>
      {sortedScans.map(s => (
        <ListItem
          key={s.id}
          label={dayjs(s.scanDate).format('MM/DD/YY')}
          content={s.isComplete ? 'Complete' : s.isCancelled ? 'Cancelled' : 'Not Complete'}
          onClick={() => navigate(`/clients/${clientId}/scans/${s.id}`)}
        />
      ))}
    </div>
  );
}